module.exports = __webpack_public_path__ + "static/media/Tribeca.7663e6f0.ttf";